<template>
  <div class="tipBox">
    <el-dialog
      title="提示"
      :visible.sync="isLoginVisible"
      width="30%"
      style="margin-top: 17vh"
      class="isLogin">
      <div class="info">请先登录</div>
      <div slot="footer" class="dialog-footer">
        <div class="btn" @click="goLogin">确 定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
export default {
  data() {
    return {
        isLoginVisible:false
    };
  },
  props:{
    isVisible:{
      type:Boolean
    }
  },
  created() {
    // 获取兄弟组件传来的值
    Bus.$on("getLoginVisible", (data) => {
        this.isLoginVisible = data
    })
  },
  methods: {
    goLogin() {
      this.$router.push({
        path:'/User/Login'
      })
    },
  },
};
</script>

<style lang="less" scoped>
.isLogin /deep/.el-dialog__header {
  color: #fff;
  background-color: #bb0015;
  height: 42px;
  border-bottom: none;
  padding: 0 20px;
}
.isLogin /deep/.el-dialog__title {
  line-height: 42px;
  font-size: 18px;
  color: #fff;
}
.isLogin /deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 30px;
}
.isLogin /deep/.el-dialog__headerbtn {
  position: absolute;
  top: 7px;
  right: 13px;
}
.isLogin /deep/.el-dialog__body {
  padding: 0;
}
.isLogin /deep/.el-dialog__footer {
  padding: 0 0 40px 0;
  text-align: center;
}

.isLogin .info {
  width: 100%;
  text-align: center;
  padding: 40px 0;
  font-size: 18px;
  color: #666;
}
.isLogin .btn {
  width: 122px;
  height: 44px;
  color: #fff;
  line-height: 44px;
  text-align: center;
  background-color: #bb0015;
  border-radius: 5px;
  margin: 0 auto;
  cursor: pointer;
}
</style>